<template>
  <div>
    <table class="create-tender-table">
      <thead>
        <tr class="create-tender-head">
          <th>
            <Checkbox :checked="allRowsSelected" @check="handleSelectAll" />
          </th>
          <th />
          <th>{{ $t('Description of work') }}</th>
          <th>{{ $t('Unit') }}</th>
          <th class="row-quantity">
            {{ $t('Quantity') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in nestedRows"
          :key="row.id"
          class="create-tender-row"
          :class="{
            _section: row.group_level > 0,
            _selected: selectedRowsHelper.includes(row.id),
            _disabled: disabledRows.includes(row.id),
            _hidden: hiddenRows.includes(row.id),
          }"
        >
          <td>
            <Checkbox
              :disabled="disabledRows.includes(row.id)"
              :checked="selectedRowsHelper.includes(row.id)"
              @check="(checked) => selectRow(checked, row)"
            />
          </td>
          <template v-if="row.group_level > 0">
            <td class="create-tender-row__number create-tender-row__index">
              {{ row.num }}
            </td>
            <td
              class="create-tender-row create-tender-row_description _section _bold"
              @click="hideRows(row.num)"
            >
              {{ row.description_of_works }}
            </td>
          </template>
          <template v-else>
            <td class="create-tender-row__number" />
            <td class="create-tender-row_description create-tender-row_description-nested">
              <span class="text-ellipsis spacex-8">
                <span class="create-tender-row__index">{{ row.num }}</span>
                <span>{{ row.description_of_works }}</span>
              </span>
            </td>
            <td>{{ get(row, 'unit.name', '') }}</td>
            <td class="row-quantity">
              {{ addSpaces(row.quantity) }}
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Checkbox from '@/components/ui/Checkbox';
  import get from 'lodash.get';
  import addSpaces from '@/utils/formatting/add-spaces';

  export default {
    name: 'CreateTenderTable',
    components: {
      Checkbox,
    },
    model: {
      prop: 'selected-rows',
      event: 'select',
    },
    props: {
      rows: {
        type: Array,
        required: true,
      },
      order: {
        type: Number,
        required: true,
      },
      selectedRows: {
        type: Array,
        required: true,
      },
      disabledRows: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        mainHiddenRows: [],
        selectedRowsHelper: [],
      };
    },
    computed: {
      hiddenRows() {
        return this.nestedRows
          .filter((nRow) =>
            this.mainHiddenRows.some((hRow) => nRow.num.indexOf(hRow) === 0 && nRow.num !== hRow)
          )
          .map((row) => row.id);
      },
      nestedRows() {
        let lvl1 = 0;
        let lvl2 = 0;
        let newRows = [];
        newRows = this.rows.map((row) => {
          if (row.group_level > 0) {
            lvl2 = 0;
            return {
              ...row,
              num: row.group_level === 1 ? `${++lvl1}` : `${lvl1}.${++lvl2}`,
            };
          } else {
            return {
              ...row,
              num: `${lvl1}.${++lvl2}`,
            };
          }
        });
        return newRows;
      },
      allRowsSelected() {
        return this.selectedRows.length > 0 && this.selectedRows.length === this.nestedRows.length;
      },
    },
    watch: {
      selectedRows(rows) {
        this.selectedRowsHelper = rows;
      },
    },
    created() {
      this.selectedRowsHelper = this.selectedRows;
    },
    methods: {
      handleSelectAll(select) {
        if (select) {
          this.selectedRowsHelper = this.nestedRows
            .map((row) => row.id)
            .filter((row) => !this.disabledRows.includes(row));
        } else {
          this.selectedRowsHelper = [];
        }

        this.emitRows(true);
      },
      addRow(rowId) {
        if (!this.selectedRowsHelper.includes(rowId)) this.selectedRowsHelper.push(rowId);
      },
      deleteRow(rowId) {
        this.selectedRowsHelper = this.selectedRowsHelper.filter(
          (selectedRow) => selectedRow !== rowId
        );
      },
      selectRow(checked, row) {
        if (checked) {
          this.addRow(row.id);
          if (row.group_level > 0) {
            this.nestedRows.forEach((nRow) => {
              // Сравнивает начало num (cм. computed - nestedRows())
              if (nRow.num.indexOf(row.num) === 0) this.addRow(nRow.id);
            });
          } else {
            // Выбраны все пункты группы, а она нет
            this.selectMainRow(row);
          }
        } else {
          this.deleteRow(row.id);
          if (row.group_level > 0) {
            this.nestedRows.forEach((nRow) => {
              if (nRow.num.indexOf(row.num) === 0) this.deleteRow(nRow.id);
            });
          } else {
            // Ни один пункт группы не выбан, а она да
            this.selectMainRow(row, false);
          }
        }

        this.emitRows();
      },
      hideRows(num) {
        const index = this.mainHiddenRows.indexOf(num);
        if (index > -1) {
          this.mainHiddenRows.splice(index, 1);
        } else {
          this.mainHiddenRows.push(num);
        }
      },
      selectMainRow(row, select = true) {
        let count = 0;
        let selectedCount = 0;
        let mainRow = null;
        this.nestedRows.forEach((nRow, idx) => {
          if (nRow.num.indexOf(row.num) === 0) {
            if (mainRow === null && this.nestedRows[idx - 1]?.group_level > 0) {
              mainRow = this.nestedRows[idx - 1];
            }
            count++;
            selectedCount++;
          }
        });

        if (count && count === selectedCount && mainRow !== null) {
          select
            ? this.selectedRowsHelper.push(mainRow.id)
            : (this.selectedRowsHelper = this.selectedRowsHelper.filter(
                (rowId) => rowId !== mainRow.id
              ));
        }
      },
      addSpaces,
      get,
      emitRows(isAll = false) {
        this.$emit('select', this.selectedRowsHelper, isAll);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  thead,
  tbody,
  tr {
    display: contents;
  }

  table {
    display: grid;
    margin: 10px 20px;
    box-shadow: inset -1px -1px 0px #e8ebf0;
    grid-template-columns: 36px 40px 370px 100px 100px;
  }

  td,
  th {
    box-shadow: 1px 1px 0 0 $grey100 inset;
  }

  .create-tender-head {
    th {
      padding: 10px 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: $text-secondary;
      font-weight: 500;
      font-size: 14px;
      box-shadow: inset 0px -2px 0px #e8ebf0, inset 1px 1px 0px #e8ebf0;
    }
  }

  .create-tender-row {
    td {
      padding: 6px 8px;

      display: flex;
      flex-direction: row;
      align-items: center;
    }
    font-weight: 500;
    font-size: 14px;
    color: $grey900;
    &_description {
      box-shadow: 0 1px 0 0 #e8ebf0 inset;
      &-nested {
        padding-left: 40px;
      }
    }
  }

  .create-tender-row._disabled {
    color: $grey300;
  }

  .create-tender-row._section {
    cursor: pointer;
    grid-column: 3/6;
  }

  .create-tender-row._hidden {
    display: none;
  }

  .create-tender-row._selected td {
    &.selected-td {
      color: $primary600;
    }
    background-color: $grey50;
  }

  .create-tender-row._section td {
    background-color: $primary50;
    color: $grey900;
  }

  .create-tender-row._bold {
    font-weight: bold;
  }

  .create-tender-row__index {
    font-weight: 500;
    font-size: 14px;
    color: $text-tertiary !important;
  }

  .create-tender-row__number {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .row-quantity {
    justify-content: flex-end;
  }
</style>
